import { Platform } from '@angular/cdk/platform';

import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { detectDeviceType } from '../../utils-fn/device-type.utils';
import { deviceDetectorActions } from './device-detector.actions';
import { DeviceType, NativeAppType } from '../../types/device-types';

export interface DeviceInfo {
  deviceType: DeviceType;
  nativeAppType: NativeAppType | null;
  isTabletBreakpoint: boolean;
}

export interface DeviceDetectorState extends DeviceInfo {
  platform: (keyof Platform)[] | null;
  isMacOs: boolean;
}

const { deviceType, isTabletBreakpoint, nativeAppType } = detectDeviceType();

const INITIAL_STATE: DeviceDetectorState = {
  deviceType,
  platform: null,
  nativeAppType,
  isTabletBreakpoint,
  isMacOs: false,
};

const deviceDetectorStoreReducer = createReducer(
  INITIAL_STATE,
  on(deviceDetectorActions.detected, (state, { detectedDevice }): DeviceDetectorState => {
    return {
      ...state,
      ...detectedDevice,
      nativeAppType: detectedDevice.nativeAppType ?? state.nativeAppType,
    };
  }),
  on(deviceDetectorActions.setNativeAppType, (state, { nativeAppType }): DeviceDetectorState => {
    return {
      ...state,
      nativeAppType,
    };
  })
);

export const deviceDetectorStoreFeature = createFeature({
  name: 'deviceDetector',

  reducer: deviceDetectorStoreReducer,

  extraSelectors: ({ selectPlatform }) => ({
    selectIsMobileOS: createSelector(selectPlatform, (platform) => {
      if (!platform) {
        return false;
      }

      return ['ANDROID', 'IOS'].filter((x) => platform.includes(x as keyof Platform)).length > 0;
    }),
  }),
});
